// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"styles-module__avatarContainer___3oLXW","avatarImage":"styles-module__avatarImage___27VJN"};